import { useState } from "react"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { useToast } from "@/components/ui/use-toast"
import { createFavoriteGroup } from "../services/favoritesService"

interface CreateFavoriteGroupModalProps {
  isOpen: boolean
  onClose: () => void
  onGroupCreated: () => void
}

export function CreateFavoriteGroupModal({
  isOpen,
  onClose,
  onGroupCreated,
}: CreateFavoriteGroupModalProps) {
  const [groupName, setGroupName] = useState("")
  const [loading, setLoading] = useState(false)
  const { toast } = useToast()

  const handleCreateGroup = async () => {
    if (!groupName.trim()) {
      toast({
        title: "Erro",
        description: "O nome do grupo é obrigatório.",
        variant: "destructive",
      })
      return
    }

    setLoading(true)
    try {
      await createFavoriteGroup({ appfav_descricao: groupName })
      toast({
        title: "Sucesso",
        description: "Grupo criado com sucesso!",
      })
      onGroupCreated()
      onClose()
    } catch (error) {
      toast({
        title: "Erro",
        description: "Falha ao criar o grupo.",
        variant: "destructive",
      })
    } finally {
      setLoading(false)
      setGroupName("")
    }
  }

  return (
    <Dialog
      open={isOpen}
      onOpenChange={onClose}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Criar Novo Grupo de Favoritos</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <Input
            placeholder="Nome do grupo"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
          />
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button
              variant="outline"
              onClick={onClose}
            >
              Cancelar
            </Button>
          </DialogClose>
          <Button
            onClick={handleCreateGroup}
            disabled={loading}
          >
            {loading ? "Criando..." : "Criar Grupo"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
